import { Chip } from '@/components/DesignSystem';
import { Color } from '@/themes/MUITheme/palette';
import { ProcessingStatus } from '@shared/enums/ProcessingStatus';
import React from 'react';

export const FriendlyProcessingStatus: Record<ProcessingStatus, string> = {
  [ProcessingStatus.Failed]: 'Failed',
  [ProcessingStatus.InProgress]: 'In progress',
  [ProcessingStatus.Processed]: 'Successful',
  [ProcessingStatus.Unprocessed]: 'Queued',
};

const ProcessingStatusColor: Record<ProcessingStatus, Color> = {
  [ProcessingStatus.Failed]: 'error',
  [ProcessingStatus.InProgress]: 'info',
  [ProcessingStatus.Processed]: 'success',
  [ProcessingStatus.Unprocessed]: 'warning',
};

interface ProcessingStatusChipProps {
  processingStatus: ProcessingStatus,
  testID: string,
}

export const ProcessingStatusChip = ({
  processingStatus,
  testID,
}: ProcessingStatusChipProps) => (
  <Chip
    color={ProcessingStatusColor[processingStatus]}
    label={FriendlyProcessingStatus[processingStatus]}
    size="small"
    sx={{ padding: 0 }}
    testID={testID}
  />
);
